export default {"src":"/_next/static/media/visa.675dfb3a.svg","height":20,"width":30,"blurWidth":0,"blurHeight":0};